<template>
  <Modal @close="$emit('close')" img="Modal-background.png" name="Block chat">
    <div class="admin-modal">
      <div class="field">
        <p>Block chat access for {{ username }} for:</p>

        <div class="duration-wrapper">
          <div class="duration-type">
            <label>
              <input v-model="blockDurationUnit" type="radio" value="seconds" />
              Seconds
            </label>

            <label>
              <input v-model="blockDurationUnit" type="radio" value="minutes" />
              Minutes
            </label>

            <label>
              <input v-model="blockDurationUnit" type="radio" value="hours" />
              Hours
            </label>

            <label>
              <input v-model="blockDurationUnit" type="radio" value="days" />
              Days
            </label>

            <label>
              <input v-model="blockDurationUnit" type="radio" value="months" />
              Months
            </label>

            <label>
              <input v-model="blockDurationUnit" type="radio" value="years" />
              Years
            </label>
          </div>
          <div class="selected-duration-wrapper">
            <input
              v-model.number="blockDuration"
              type="number"
              min="1"
              placeholder="Duration"
            />
            <span>{{ blockDurationUnit }}</span>
          </div>
        </div>
      </div>
      <div class="field">
        <p>Reason:</p>
        <input
          v-model="blockReason"
          type="text"
          placeholder="Why this user should be blocked?"
          @input="blockReasonRequiredMessage = ''"
        />
        <div v-if="blockReasonRequiredMessage" class="error-text">
          <p>{{ blockReasonRequiredMessage }}</p>
        </div>
      </div>
      <div v-if="blockError" class="error-text">
        <p>{{ blockError }}</p>
      </div>
      <div class="actions">
        <Button type="primary__white" size="small" @click="$emit('close')">
          Cancel
        </Button>
        <Button type="primary" size="small" @click="confirm"> Block </Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import Button from "@/components/uikit/Button.vue"
import Modal from "@/components/uikit/Modal.vue"
import { defineComponent, PropType } from "vue"
import { UserType } from "../../types"
import { callApi } from "@/services/api"
import { AxiosError } from "axios"
import { bus } from "@/utils"
export default defineComponent({
  name: "BlockUserModal",
  components: { Button, Modal },
  data() {
    return {
      blockDuration: 60,
      blockDurationUnit: "seconds" as
        | "seconds"
        | "minutes"
        | "hours"
        | "days"
        | "months"
        | "years",
      blockReason: "",
      blockReasonRequiredMessage: "",
      blockError: "",
    }
  },
  props: {
    user: {
      type: Object as PropType<UserType>,
      required: true,
    },
    mode: {
      type: String as PropType<"admin" | "moderator">,
      default: "admin",
    },
  },
  computed: {
    blockDurationSeconds() {
      const multipliers = {
        seconds: 1,
        minutes: 60,
        hours: 60 * 60,
        days: 24 * 60 * 60,
        months: 30 * 24 * 60 * 60,
        years: 365 * 24 * 60 * 60,
      }

      return this.blockDuration * multipliers[this.blockDurationUnit]
    },
  },
  methods: {
    async confirm() {
      if (!this.user) return

      if (!this.blockReason) {
        this.blockReasonRequiredMessage = "Field is required"
        return
      }

      if (this.blockDurationSeconds < 60) {
        this.blockReasonRequiredMessage =
          "Block duration should be at least 60 seconds"
        return
      }

      try {
        await callApi[this.mode].blockUserChat(this.user.id, {
          seconds: this.blockDurationSeconds,
          reason: this.blockReason,
        })

        bus.emit("chat-user:blocked", JSON.stringify(this.user))
      } catch (error) {
        const err = error as AxiosError<{ messages: Record<string, string> }>

        if (err.status === 422) {
          this.blockError = err.response?.data?.messages[0] || ""
        }
      }

      this.$emit("close")
    },
  },
})
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .duration-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .selected-duration-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
}
</style>
